import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { StackedBarchartModule } from '../stacked-bar-chart/stackedbarchart.module';
import { ForecastComponent } from './forecast.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StackedBarchartModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    ForecastComponent]
})
export class ForecastModule { }
